import styled from 'styled-components';

export const CardContent = styled.div`
    margin-bottom: 3.2rem;
    margin-right: 4rem;
`;
